import React from 'react';

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-3xl font-semibold mb-6">
          Ask Arthur Terms and Conditions
        </h1>
        <p className="text-sm text-gray-500 mb-8">
          Last Updated: September 28, 2025
        </p>

        <div className="prose prose-gray max-w-none space-y-4">
          <p>
            By checking the consent box and clicking “Submit,” you voluntarily
            opt in to receive SMS communications and agree to the following
            terms and conditions governing your participation in the AskArthur
            SMS communication program, provided by Ronin Tech LLC (“AskArthur”)
            and its affiliated restaurant partners. These terms apply only to
            individuals who have expressly opted in to receive SMS messages; if
            you do not check the consent box, these terms do not apply to you.
          </p>

          <h2>1. Consent to Receive Automated Messages</h2>
          <p>
            By opting in, you expressly consent to receive recurring automated
            SMS/MMS text messages at the mobile number provided. Messages may
            include transactional notifications (e.g., order updates,
            pickup/ready notifications, delivery notifications) and customer
            support communications. Consent is not a requirement for purchase.
            Compliance includes the TCPA, CASL, and GDPR.
          </p>

          <h2>2. Message Frequency &amp; Carrier Charges</h2>
          <p>
            Message frequency varies based on your interactions and service
            usage. Standard message and data rates may apply as determined by
            your wireless carrier and mobile plan. AskArthur is not responsible
            for such charges.
          </p>

          <h2>3. Opt-Out &amp; Customer Support</h2>
          <p>
            You may opt out at any time by replying STOP to cease all messages
            or HELP for assistance. Alternatively, contact us at
            support@AskArthur or mail: Ronin Tech LLC 100 Norfolk St Apt 5c, New
            York, NY 10003.
          </p>

          <h2>4. Data Collection, Use &amp; Storage</h2>
          <p>
            AskArthur collects and securely stores your phone number, opt-in
            timestamp, IP address, and SMS interaction data to deliver the
            requested services and support. Data may be processed in the United
            States or other jurisdictions and is retained only as necessary or
            as required by law.
          </p>

          <h2>5. Privacy &amp; Data Protection</h2>
          <p>
            We do not sell or rent your personal data. Your information is used
            solely for the messaging services you have opted into and for
            customer support, in accordance with our{' '}
            <a href="/legal/privacy" className="underline">
              Privacy Policy
            </a>
            .
          </p>

          <h2>6. Eligibility</h2>
          <p>
            Participants must be at least 18 years of age and reside where SMS
            programs are legally permitted.
          </p>

          <h2>7. Changes to Terms &amp; Conditions</h2>
          <p>
            AskArthur may update these terms to reflect changes in laws,
            regulations, or services. Continued participation signifies
            acceptance of updates.
          </p>

          <h2>8. Specific Provisions for Canada and the EU</h2>
          <p>
            Canadian residents agree to receive electronic messages under CASL
            and may withdraw consent anytime by replying STOP or contacting
            support. EU residents acknowledge processing based on consent under
            GDPR Article 6(1)(a) and retain the right to withdraw consent,
            request access, rectification, or deletion by contacting
            privacy@AskArthur.
          </p>
        </div>
      </div>

      <footer className="py-10 text-center text-gray-500 text-sm">
        <div>2025 Ronin Tech LLC DBA ©Ask Arthur. All rights reserved.</div>
        <div>100 Norfolk St</div>
        <div>New York, NY 10002</div>
      </footer>
    </div>
  );
}
